import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import useLoadingScreenStyles from './useLoadingScreenStyles';

const LoadingScreen = () => {
  const { classes } = useLoadingScreenStyles();

  return (
    <Box className={classes.container}>
      <CircularProgress size={60} thickness={4} />
      <p className={classes.loadingText}>Loading, please wait...</p>
    </Box>
  );
};

export default LoadingScreen;
